module.exports = __webpack_public_path__ + "static/media/5.dd7a1eef.png";